import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatCheckboxChange } from '@angular/material';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import * as viewActions from '@view/store/view.actions';
import * as workbookActions from '@workbook/store/workbook.actions';
import * as wbSelectors from '@workbook/store/workbook.selectors';

import { OpenWorkbookAs } from '@utils';
import { Workbook, View } from '@models';
import { RootState } from '@base/rootReducers';
import * as workbookSelectors from '@workbook/store/workbook.selectors';
import * as viewSelectors from '@view/store/view.selectors';
import { take, takeUntil } from 'rxjs/operators';
import * as fromUtils from '@utils';

@Component({
  selector: 'app-setview',
  templateUrl: './setview.component.html',
  styleUrls: ['./setview.component.sass']
})
export class SetViewComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private wbook$: Observable<Workbook>;
  private requesting = false;
  private selectedView = null;
  workbook: Workbook;
  showSpinner: boolean;

  openAsImage = false;
  acceptButtonDisabled = false;
  disableViewList = false;

  constructor(
    private store: Store<RootState>,
    public dialogRef: MatDialogRef<SetViewComponent>,
    @Inject(MAT_DIALOG_DATA) public info: any,
    private snackBar: MatSnackBar,
  ) {
    this.showSpinner = false;
    this.workbook = null;
  }

  ngOnInit() {
    this.wbook$ = this.store.select(workbookSelectors.getRow);
    this.wbook$.pipe(takeUntil(this.destroy$))
    .subscribe((w: Workbook) => {
      this.openAsImage = (w.open_as === OpenWorkbookAs.Image);
      this.disableViewList = this.openAsImage;
      this.workbook = w;
    });

    // suscriptor escuchando cambios en tipo de apertura del reporte
    this.store.select(wbSelectors.successfullyApplied)
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      ({successfullyApplied, }) => {
        if (successfullyApplied && this.requesting) {
          this.requesting = false;
        }
    });

    // suscriptor escuchando cambios de vista inicial
    this.store.select(viewSelectors.successfullyApplied)
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      ({successfullyApplied, }) => {
        if (successfullyApplied && this.requesting) {
          this.requesting = false;
          console.log('Vista inicial');
        }
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  private sendResponse() {
    this.showSpinner = false;
    this.dialogRef.close(this.workbook);
  }

  private openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 3000,
    });
  }

  setStatus(v: View) {
    const newStatus = !v.default_view;
    this.workbook.views.map((view) => view.default_view = false);
    v.default_view = newStatus;
    this.selectedView = v;
  }

  selectionChanged(option: MatCheckboxChange) {
    this.openAsImage = option.checked;
  }

  applyChanges() {
    this.requesting = true;
    const wbId = (fromUtils.getReferencedValue(this.workbook, 'id'));
    const openingType = (this.openAsImage) ? fromUtils.OpenWorkbookAs.Image : fromUtils.OpenWorkbookAs.Report;
    const payload = {workbookId: wbId, openAs: openingType};

    if (this.selectedView === null && this.openAsImage) {
      const hasActiveView = (this.workbook.views.filter((v) => v.default_view === true)).length > 0;

      if (!hasActiveView) {
        this.openSnackBar('Debe seleccionar una vista', 'Atencion');
        return false;
      }
    }

    if (this.selectedView !== null) {
      if (this.openAsImage) {
        const hasActiveView = (this.workbook.views.filter((view) => view.default_view === true)).length > 0;
        if (!hasActiveView) {
          this.openSnackBar('Debe seleccionar una vista', 'Atencion');
          return false;
        }
      }
      const v = this.selectedView;
      const payload2 = {viewId: v.id, newStatus: v.default_view};
      this.store.dispatch(viewActions.changeDefaultViewStatus(payload2));
    } else {
      if (this.openAsImage) {
        const hasActiveView = (this.workbook.views.filter((v) => v.default_view === true)).length > 0;
        if (!hasActiveView) {
          this.openSnackBar('Debe seleccionar una vista', 'Atencion');
          return false;
        }
      }
    }

    this.workbook.open_as = openingType;
    this.store.dispatch(workbookActions.setOpeningType(payload));
    this.sendResponse();
  }
}
